import React from 'react';
import { Redirect } from 'react-router-dom';
import { ERROR_PATH } from 'shared/consts';

export const DefaultRedirect: React.FC = (): JSX.Element => {
  return <Redirect to={ERROR_PATH} />;
};
